export const TOUCH_TARGET = "data-touch-target";
export const TOUCH_TARGET_CLIENT_X = `${TOUCH_TARGET}-client-x`;
export const TOUCH_TARGET_CLIENT_Y = `${TOUCH_TARGET}-client-y`;
export const TOUCH_TARGET_START = `${TOUCH_TARGET}-start`;
export const TOUCH_TARGET_MOVE_ON = `${TOUCH_TARGET}-move-on`;
export const TOUCH_TARGET_MOVE_OFF = `${TOUCH_TARGET}-move-off`;
export const TOUCH_TARGET_END = `${TOUCH_TARGET}-end`;
export const TOUCH_TARGET_STOP_PROPAGATION = `${TOUCH_TARGET}-stop-propagation`;
